import React, { useEffect, useMemo } from 'react';

import VacancyFilter from '../../components/Filter/VacancyFilter';
import { Link } from 'react-router-dom';

import VacancyTable from './VacancyTable';
import { useForm } from 'react-hook-form';
import { usePermissions } from '../../hooks/usePermissions';
import AccessDenied from '../../components/AccessDenied/AccessDenied';

export const filterVacancy = [
  {
    label: 'Активные',
    value: 'active',
    params: {
      is_active: true,
      is_broadcast: true,
    },
    emptyText: 'Активный вакансий нет',
  },
  {
    label: 'На модерации',
    value: 'moderation',
    params: {
      is_active: true,
      is_verified: false,
    },
    emptyText: 'На модерации вакансий нет',
  },
  {
    label: 'Неактивные',
    value: 'inactive',
    params: {
      is_active: true,
      is_verified: true,
      is_broadcast: false,
    },
    emptyText: 'Неактивных вакансий нет',
  },
  {
    label: 'Удаленные',
    value: 'deleted',
    params: { is_active: false },
    emptyText: 'Удаленных вакансий нет',
  },
];

const VACANCY_TAB_PERMISSIONS = {
  active: ['view_active_vacancy'],
  moderation: ['view_moderation_vacancy', 'view_moderation'],
  inactive: ['view_inactive_vacancy'],
  deleted: ['view_deleted_vacancy'],
};

function VacancyIndex() {
  const { hasPermission, hasAnyPermission } = usePermissions();
  const hasFullVacancyAccess = hasPermission('view_any_vacancy');
  const canCreateVacancy = hasPermission('add_any_vacancy');
  const canCreateHr = hasPermission('add_any_hr');

  const availableVacancyFilters = useMemo(() => {
    if (hasFullVacancyAccess) {
      return filterVacancy;
    }

    return filterVacancy.filter((item) => {
      if (item.value === 'moderation') {
        return hasAnyPermission(VACANCY_TAB_PERMISSIONS.moderation);
      }

      const permission = VACANCY_TAB_PERMISSIONS[item.value]?.[0];
      return permission ? hasPermission(permission) : false;
    });
  }, [hasFullVacancyAccess, hasAnyPermission, hasPermission]);

  const form = useForm({
    defaultValues: {
      vacancy: [],
      isShowAction: false,
      tabState: availableVacancyFilters[0] || null,
    },
  });

  useEffect(() => {
    const currentTab = form.getValues('tabState');
    const hasCurrentTabAccess = currentTab && availableVacancyFilters.some((item) => item.value === currentTab.value);

    if (!hasCurrentTabAccess) {
      form.setValue('tabState', availableVacancyFilters[0] || null);
      form.setValue('vacancy', []);
      form.setValue('isShowAction', false);
    }
  }, [availableVacancyFilters, form]);

  const hasVacancyListPermissions = availableVacancyFilters.length > 0;

  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px]">
      <div className="w-full mt-6 p-2">
        <div className="flex flex-row justify-between gap-1">
          <p className="text-2xl font-medium">Вакансии</p>
          <p className="flex flex-wrap justify-center items-center">
            {canCreateHr && (
              <Link to={`/createJob`}>
                <button type="button" className="text-center border rounded py-2 px-2 text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  {'Создать поиск и подбор'}
                </button>
              </Link>
            )}{' '}
            {canCreateVacancy && (
              <Link to={`/create`}>
                <button type="button" className="text-center border rounded py-2 px-2 text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300 m-2">
                  {'Создать вакансию'}
                </button>
              </Link>
            )}
          </p>
        </div>
      </div>
      <div className="w-full flex flex-col first:flex-row zero:justify-evenly">
        {hasVacancyListPermissions ? (
          <>
            <VacancyTable isAll={true} form={form} filter={availableVacancyFilters} />
            <div className="hidden justify-start w-[30%] first:flex zero:p-1 xs:p-4 flex-col">
              <VacancyFilter form={form} />
            </div>
          </>
        ) : (
          <AccessDenied
            size="medium"
            title="Доступ ограничен"
            description="У вас нет полномочий для просмотра списка вакансий."
            supportText="Для изменения доступа напишите в поддержку:"
          />
        )}
      </div>
    </div>
  );
}

export default VacancyIndex;
